/**
 * @requires Google Analytics tracking code
 */
(function() {

    var trackedLink = '.js-ga-track';
    var $trackedLink = $(trackedLink);

    // ====================================================================== //
    // Functions
    // ====================================================================== //

    /**
     * @function `gaTrack`
     *
     * Tracks the click event on the clicked link.
     */
    function gaTrack() {
        var $this = $(this);
        var data = {
            hitType: 'event',
            file: $this.attr('href')
        };
        if( $this.data('ga-category') && $this.data('ga-category').length ) {
            data.eventCategory = $this.data('ga-category');
        }
        if( $this.data('ga-action') && $this.data('ga-action').length ) {
            data.eventAction = $this.data('ga-action');
        }
        if( $this.data('ga-label') && $this.data('ga-label').length ) {
            data.eventLabel = $this.data('ga-label');
        }
        if (typeof ga !== 'undefined') {
            ga('send', data);
        }
        return;
    }

    // ====================================================================== //
    // Click events
    // ====================================================================== //

    _$document.on('click', trackedLink, gaTrack);

})();
